import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { Table, Header } from 'semantic-ui-react';

import ListRow from './ListRow';

class VinBlacklistsList extends Component {
  render() {
    const { onSelectVinBlacklist, vinBlacklists } = this.props;
    const listRow = ListRow(onSelectVinBlacklist);

    const headerRow = (
      <Table.Row>
        <Table.HeaderCell>VIN</Table.HeaderCell>
        <Table.HeaderCell>Expiration Date</Table.HeaderCell>
        <Table.HeaderCell>Notes</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
        <Table.HeaderCell>Created At</Table.HeaderCell>
        <Table.HeaderCell />
      </Table.Row>
    );

    return (
      <div>
        <Header>Vin Blacklist</Header>
        <div>
          <Table
            celled
            selectable
            padded
            renderBodyRow={listRow}
            tableData={vinBlacklists}
            headerRow={headerRow}
            size='tiny'
            compact='very'
            style={{ fontSize: '90%' }}
            striped
          />
        </div>
      </div>
    );
  }
}

VinBlacklistsList.propTypes = {
  onSelectVinBlacklist: PropTypes.func.isRequired,
  vinBlacklists: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    vin: PropTypes.string,
    expirationDate: PropTypes.string,
    notes: PropTypes.string,
    status: PropTypes.string,
    createdAt: PropTypes.string,
  })),
};

VinBlacklistsList.defaultProps = {
  vinBlacklists: [],
};

export default compose(withApollo, withRouter)(VinBlacklistsList);
